module.exports = __webpack_public_path__ + "static/img/banner.10f830b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/banner.png
// module id = RLfh
// module chunks = 2